import { Component, OnInit } from '@angular/core';
import { LocalAuthService } from 'app/core/auth/auth.service';

@Component({
  selector: 'app-logout',
  standalone: true,
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit{
  constructor(private authService: LocalAuthService) {}

    ngOnInit(): void {
        this.authService.signOutDirect();
    }
}
